import type { SpaceId } from "./space";

export const mockSpaceId = "testSpaceId" as SpaceId;
